module.exports = __webpack_public_path__ + "img/digital-gate-with-separator-mask-with-margin.37a8c2e3.png";